import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const CostDitributionWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 32px;

  .solo-cost-distribution-text {
    color: ${theme.colors.cardDateText};
    font-family: Quicksand, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-top: -4px;
  }
`

export const CostDistributionHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;

  .title {
    color: ${theme.colors.foreground};
    font-family: Quicksand, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.1px;
  }
`

export const CostDistributionList = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`
